export const transition = {
    duration: .25,
    ease: [.56, .03, .12, 1.04]
};

export const variants = {
    hideMenu: {
        opacity: 0,
        y: 0,
    },
    showMenu: width => ({
        opacity: 1,
        y: width > 500 ? '50%' : '-95%',
    }),
    hideCategories: width => ({
        opacity: 0,
        x: width > 500 ? '50%' : 0,
        y: width > 500 ? '-50%' : 0,
        boxShadow: width > 500 ? 'none' : '0 -2px 5px rgba(0,0,0,0)'
    }),
    showCategories: width => ({
        opacity: 1,
        x: 0,
        y: width > 500 ? '-50%' : '-100%',
        boxShadow: width > 500 ? 'none' : '0 -2px 5px rgba(0,0,0,.15)'
    }),
}